import { css, Flex, styled } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

const hideOnLoading = () => css`
  visibility: hidden;
  opacity: 0;
`;

const showOnLoading = () => css`
  visibility: initial;
  transition: ${animationTransition('opacity')};
`;

export const StyledFlexAloha = styled(Flex)<{ loading: boolean }>`
  width: 100%;
  flex-direction: column;
  ${({ loading }) => (loading ? hideOnLoading : showOnLoading)}
`;
